<template>
  <div class="seller-in-steps">

            <li v-if="type == 'a'" :class="[active >= 0 ? 'steps-on': '']">
              <span>提交订单</span>
              <div class="o-icon-br steps-ok" >
                <i class="o-icon icon-smt"></i>
              </div>
              <label  class='o-icon steps-s' :class="[active > 0 ? 'steps-ok' : '']"></label>
              <span class="time-step">{{time.orderTime}}</span>
            </li>

          <li v-if="type == 'a' && active != 5" :class="[active >= 1  ? 'steps-on' : '']">
            <span>积分兑换</span>
            <div class='o-icon-br' :class="[active >= 1  ? 'steps-ok' : '']">
              <i class="o-icon icon-pay"></i>
            </div>
            <label class='o-icon steps-s' :class="[active >= 1  ? 'steps-ok' : '']"></label>
            <span class="time-step">{{time.payTime}}</span>
          </li >

          
          <li v-if="active != 5" :class="[active >= 2  ? 'steps-on' : '']">
              <span>卖家发货</span>
              <div class='o-icon-br' :class="[active >= 2  ? 'steps-ok' : '']">
                <i class="o-icon icon-deliver"></i>
              </div>
              <label class='o-icon steps-s' :class="[active > 2  ? 'steps-ok' : '']"></label>
              <span class="time-step">{{time.deliveryTime}}</span>
          </li >
          
          <li :class="[active >= 3 ? 'steps-on' : '',active >= 3 ? 'steps-ok' : '',type != 'a' ? 'w-h' : '']">
            <span>{{type == 'a' ?  active == 5 ?  '已关闭' : "已完成" : "买家确认收货"}}</span>
            <div class='o-icon-br' :class="[active >= 3  ? 'steps-ok' : '']">
              <i class="o-icon icon-complete"></i>
            </div>
            <span class="time-step">{{type == 'a' ?  active == 5 ?  time.closeTime : time.completedTime : time.completedTime}}</span>
          </li >
          
        </div >
</template>
<script>
export default {
  name: "Step",
  props: {
    type: String,
    active: Number,
    time: Object
  }
};
</script>
<style>
.seller-in-steps {
  margin: 30px auto 20px;
  width: 100%;
  display: table;
  text-align: center;
  content: " ";
}
.seller-in-steps li:last-child {
  width: 60px;
}
.seller-in-steps li:last-child.w-h {
  width: 92px;
}

/*默认*/
.o-icon-br {
  width: 40px;
  height: 40px;
  border-radius: 66px;
  display: inline-block;
  border: 1px solid #cccccc;
  margin-right: 15px;
}
.o-icon {
  background: url(../assets/icon-account.png) no-repeat;
  display: inline-block;
  vertical-align: top;
  margin-top: 8px;
}

.icon-smt {
  background-position: -23px -285px;
  width: 24px;
  height: 22px;
}
.icon-pay {
  background-position: -25px -307px;
  width: 24px;
  height: 22px;
}
.icon-deliver {
  background-position: -73px -286px;
  width: 22px;
  height: 22px;
}
.icon-complete {
  background-position: -74px -308px;
  width: 23px;
  height: 22px;
}
.seller-in-steps li {
  font-size: 14px;
  border-right: none;
  text-align: center;
  width: 220px;
  line-height: 60px;
  display: inline-block;
  margin: 0;
  position: relative;
  vertical-align: top;
}
.seller-in-steps li span {
  display: block;
  height: 30px;
  line-height: 30px;
  text-align: left;
  color: #ccc;
}
.steps-s {
  background-position: 0 -351px;
  width: 150px;
  height: 23px;
}

/*已过*/
.seller-in-steps .steps-ok {
  color: #666;
}
.steps-ok.o-icon-br {
  width: 40px;
  height: 40px;
  border-radius: 66px;
  border: 1px solid #46be64;
  display: inline-block;
}
.steps-ok.steps-s {
  background-position: 0 -328px;
  width: 150px;
  height: 23px;
}

.steps-ok.o-icon-br .icon-smt {
  background-position: 0 -285px;
  width: 24px;
  height: 22px;
}
.steps-ok.o-icon-br .icon-pay {
  background-position: -2px -307px;
  width: 24px;
  height: 22px;
}
.steps-ok.o-icon-br .icon-deliver {
  background-position: -50px -286px;
  width: 22px;
  height: 22px;
}
.steps-ok.o-icon-br .icon-complete {
  background-position: -50px -308px;
  width: 23px;
  height: 22px;
}

.seller-in-steps li .time-step {
  width: 80px;
  line-height: 15px;
  text-align: center;
  margin-left: -12px;
  margin-top: -12px;
  font-size: 12px;
}
/*当前*/
.seller-in-steps .steps-on span {
  color: #46be64;
}
.seller-in-steps .steps-on {
  -webkit-animation: scode 0.4s linear 0s normal none;
  -moz-animation: scode 0.4s linear 0s normal none;
  animation: scode 0.5s linear 0s normal none;
}
@-webkit-keyframes scode {
  from {
    opacity: 0;
    -webkit-transform: scale(0, 0);
    transform-origin: bottom;
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    transform-origin: left;
  }
}
@-moz-keyframes scode {
  from {
    opacity: 0;
    -moz-transform: scale(0, 0);
    transform-origin: bottom;
  }
  to {
    opacity: 1;
    -moz-transform: scale(1, 1);
    transform-origin: left;
  }
}
@keyframes scode {
  from {
    opacity: 0;
    transform: scale(0, 0);
    transform-origin: bottom;
  }
  to {
    opacity: 1;
    transform: scale(1, 1);
    transform-origin: left;
  }
}
</style>
